module.exports = __webpack_public_path__ + "img/logo.85775a58.png";